import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { axiosErrorHandler } from "../../../swzutils";
import ChangeHistoryLog from "./ChangeHistoryLog";
const ChangeHistoryURLModal = (props) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateChanges, setStateChanges] = useState([]);
    useEffect(() => {
        if (props.open && props.url) {
            setStateLoading(true);
            axios.get(props.url)
                .then(response => setStateChanges(response.data))
                .catch(axiosErrorHandler)
                .finally(() => setStateLoading(false));
        }
    }, [props.url, props.open]);
    return (_jsx(Modal, { open: props.open, onCancel: props.onCancel, width: props.width ?? 950, title: props.title, destroyOnHidden: true, footer: [
            _jsx(Button, { htmlType: "button", onClick: props.onCancel, children: "Close" }, "close")
        ], loading: stateLoading, children: _jsx(ChangeHistoryLog, { changes: stateChanges, hidePreviousValue: props.hidePreviousValue, loading: false }) }));
};
export default ChangeHistoryURLModal;
